import { history } from '../_helpers';

export const serviceSettingsServices = {
  getServiceSettingsList,
  getServiceSettingsDetails,
  updateServiceSettingsTypes,
  updateServiceSettingsStatus,
};

function getServiceSettingsDetails(formId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/settings/${formId}`,
    requestOptions
  ).then(handleResponse);
}

function getServiceSettingsList() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/settings`,
    requestOptions
  ).then(handleResponse);
}

function updateServiceSettingsTypes(typeId, formId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "PUT",
    headers: {
      "x-access-token": user.accessToken,
      'content-type': 'application/json'
    },
    body: JSON.stringify(typeId),
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/settings/${formId}`,
    requestOptions
  ).then(handleResponse);
}

function updateServiceSettingsStatus(statusId, formId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "PUT",
    headers: {
      "x-access-token": user.accessToken,
      'content-type': 'application/json'
    },
    body: JSON.stringify(statusId),
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/settings/${formId}`,
    requestOptions
  ).then(handleResponse);
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (!response.ok) {
      if (response.status === 401) {
       
      }
      // checking token expiry
      if (response.status === 401 && data.message.includes('Invalid JWT token')) {
        //redirecting to signin page
        history.push('/auth/signin')
        //removing local storage token
        localStorage.removeItem('user');
        return;
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}
